/**
 * Runtime environment variable access using next-runtime-env.
 *
 * IMPORTANT: Do NOT use process.env.NEXT_PUBLIC_* directly.
 * Always use the env() function from this module instead.
 *
 * This enables runtime configuration without rebuilding the app.
 */
import { env as runtimeEnv } from 'next-runtime-env'

/**
 * Get a public environment variable at runtime.
 * Works on both server and client.
 *
 * @param key - Environment variable name (must start with NEXT_PUBLIC_)
 * @returns The environment variable value or undefined
 */
export function env(key: `NEXT_PUBLIC_${string}`): string | undefined {
  return runtimeEnv(key)
}

/**
 * Get a required public environment variable.
 * Throws if the variable is not set.
 *
 * @param key - Environment variable name (must start with NEXT_PUBLIC_)
 * @returns The environment variable value
 * @throws Error if the variable is not set
 */
export function envRequired(key: `NEXT_PUBLIC_${string}`): string {
  const value = env(key)
  if (!value) {
    throw new Error(`Required environment variable ${key} is not set`)
  }
  return value
}
